var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 6.66675C15.3334 6.31313 15.1929 5.97399 14.9429 5.72394C14.6928 5.47389 14.3537 5.33341 14.0001 5.33341H9.78675L10.4267 2.28675C10.4401 2.22008 10.4467 2.14675 10.4467 2.07341C10.4467 1.80008 10.3334 1.54675 10.1534 1.36675L9.44675 0.666748L5.06008 5.05341C4.81342 5.30008 4.66675 5.63341 4.66675 6.00008V12.6667C4.66675 13.0204 4.80722 13.3595 5.05727 13.6096C5.30732 13.8596 5.64646 14.0001 6.00008 14.0001H12.0001C12.5534 14.0001 13.0267 13.6667 13.2267 13.1867L15.2401 8.48675C15.3001 8.33341 15.3334 8.17341 15.3334 8.00008V6.66675ZM0.666748 14.0001H3.33341V6.00008H0.666748V14.0001Z",
    fill: "#20B1D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.670d996a31322dc8d523f916c711f0d1.svg";
export { ForwardRef as ReactComponent };